import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Input, Menu, Dropdown, Modal, Confirm } from 'semantic-ui-react';
import { showLoading, hideLoading, showMessage, hideMessage, getProducts } from '../actions';

class MiscMenu extends Component {
    state = {
        selectedSubMenu: 'materials'
    }


    handlePaymentTerms(e) {
        this.props.history.push('/payment_terms');
        this.setState({selectedSubMenu: 'paymentTerms'})
    }

    handleMisc(){
        this.props.history.push('/misc');
        this.setState({selectedSubMenu: 'materials'}) 
    }


    render() {
        const { selectedSubMenu } = this.state;

        return (
            <Fragment>
                <Menu fixed='left' vertical style={{ marginTop: '5em', marginLeft: '0em' }}>
                    <Menu.Item key='materials' name="materials" active={selectedSubMenu === 'materials'} onClick={this.handleMisc.bind(this)}>
                        Materials
                    </Menu.Item>
                    <Menu.Item  key='paymentTerms' name="paymentTerms" active={selectedSubMenu === 'paymentTerms'}  onClick={this.handlePaymentTerms.bind(this)}>
                        Payment Terms
                    </Menu.Item>

                    {/* <Menu.Item key='shipping' name="shipping" active={selectedSubMenu === 'shipping'}>
                        Shipping
                    </Menu.Item>
                    <Menu.Item key='offdays' name="offdays" active={selectedSubMenu === 'offdays'}>
                        Off Days
                    </Menu.Item> */}
                </Menu>
            </Fragment>
        )
    }
}

export default MiscMenu;